// extracted by mini-css-extract-plugin
export default {"container":"head_container__mMUFP"};